import React, { useContext, useEffect, useState } from "react";
import Cookies from 'universal-cookie';
import { MiFooter } from "../../components/footer/MiFooter";
import HeaderHome from "../../components/headerHome/HeaderHome"
import { UsuarioContext } from '../../contexts/UsuarioContext';
import { useSessionStore } from "../../hooks/useSessionStore";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useLocation, useNavigate } from "react-router-dom";
import { BannerMarket } from "../../components/home/BannerMarket";
import { SectionZero } from "../../components/home/SectionZero";
import {SectionOneProovedores} from "../../components/home/SectionOneProovedores";
import axios from 'axios';
import { Helmet } from "react-helmet";
import { SectionCuidatia } from "../../components/home/SectionCuidatia";
import myImagen1 from './img/tranquilidad.jpeg';
import paso1 from './img/ayuntamiento.png';
import paso2 from './img/empresa.png';
import paso3 from './img/ayudadomiciliot.png';
import paso4 from './img/centrodia.png';
import paso5 from './img/residencia.png';
import paso6 from './img/autonomia.png';
import "./proveedores.css";


export const Proveedores = () => {

  const [Usuario, setUsuario] = useSessionStore(UsuarioContext);
  /* Using the useSessionStore hook to get the UsuarioContext from the session storage. */
  /* Destructuring the context. */
  const [MenuLateral, setMenuLateral] = useContext(UsuarioContext)
  //const [Usuario, setUsuario] = useSessionStore({ Usuario: "Usuario" });
  const [autLocalidades, setAutLocalidades] = useState(false);
  ;

  /* Declaring a state variable called `MenuNoHayEmpresa` and initializing it with the value `false`.
  It also declares a function called `setMenuNoHayEmpresa` that can be used to update the value of
  `MenuNoHayEmpresa`. This state variable is likely used to control the display of a menu or message
  when there are no companies available in the marketplace. */
  const [MenuNoHayEmpresa, setMenuNoHayEmpresa] = useState(false);

    const [ btnSelected, setBtnSelected ] = useState();

  // El estado Empresas almacena la lista de empresas.
  const [Empresas, setEmpresas] = useState([]);
  const [empresasCargadas, setEmpresasCargadas] = useState([])

  const [ limite, setLimite ] = useState(18)
  const [ buscarNombre, setBuscarNombre ] = useState()
  const [ buscarCategoria, setBuscarCategoria ] = useState()
  const [ categoriaSeleccionada, setCategoriaSeleccionada ] = useState()
  const [ buscarLocalidad, setBuscarLocalidad ] = useState(0)
  const [ buscarProvincia, setBuscarProvincia ] = useState()

  const [ModalCafeRural, setModalCafeRural] = useState()

  const navigate = useNavigate()

  const [Mapa, setMapa] = useState(false);

  // El estado FiltroCategorias almacena el ID de la categoría a filtrar.
  const [FiltroCategorias, setFiltroCategorias] = useState();

  const [ModalUbiacion, setModalUbiacion] = useState(false);
  const [SeleccionUbicacion, setSeleccionUbicacion] = useState(false);
  const [Ubicacion, setUbicacion] = useState({
      lat: 40.41831,
      lng: -3.70275,
  });
  const [RadioUbicacion, setRadioUbicacion] = useState(0);

  const [zoom, setZoom] = useState(9);

  useEffect(() => {
    const modalSeen = sessionStorage.getItem('modalCafeRuralSeen');
    if (!modalSeen) {
      setModalCafeRural(true);
      sessionStorage.setItem('modalCafeRuralSeen', 'true');
    }
  }, []);

  /**
   * Recupera los detalles de una empresa a partir de su ID.
   * @param {number} id - El ID de la empresa a buscar.
   * @returns {Promise<Object>} Una promesa que resuelve con un objeto que contiene los detalles de la empresa.
   */
  const getEmpresa = async (id) => {
    try {
      const response = await axios.get(window.ipdirection + "prestadorServiciosCliente/" + id + "/");
      const empresa = response.data;
      // Recupera la imagen de perfil de la empresa y crea una URL para ella.
      let imagenURL = "";
      try {
        const imagenResponse = await axios.get(window.ipdirection + `imagenPerfilEmpresaCliente/${empresa.id}/`, {
          responseType: "blob"
        });
        imagenURL = URL.createObjectURL(imagenResponse.data);
        return ({ ...empresa, img: imagenURL });
      } catch (error) {
        imagenURL = window.ipdirection + "CuidatiaNuevo2026.68c5966743354987255d.png";
        return ({ ...empresa, img: imagenURL });
      }
      // Devuelve un objeto que contiene los detalles de la empresa y la URL de su imagen de perfil.
    } catch (error) {
      console.log(error);
    }
  };

  const location = useLocation()

  useEffect(() => {
    if (location.hash) {
      let location_scroll = location.hash.split('#')
      const section = document.getElementById(location_scroll[1]);
      if (section) {
        section.scrollIntoView({ behavior: 'auto' });
      }
    }
  }, [location]);


  /**
 * Recupera una lista de empresas a partir de una categoría dada.
 * @param {number} id - El ID de la categoría a buscar.
 * @returns {Promise<void>} Una promesa que resuelve cuando la lista de empresas ha sido recuperada.
 */
  useEffect(() => {
    // setBuscarCategoria(buscarCategoria)
    setBuscarCategoria(categoriaSeleccionada)
  },[categoriaSeleccionada])

  useEffect(() => {
    // setBuscarCategoria(buscarCategoria)
    if(categoriaSeleccionada != ''){
      // getEmpresas_preRegistradas()
      setCategoriaSeleccionada('')
    }
  },[buscarCategoria])
    



  const closeMenu = () => {
    if (MenuLateral === true) {
      setMenuLateral(false)
    }
    if (autLocalidades) {
      setAutLocalidades(false);
    }

  }

  /* A hook that is executed when the component is mounted. */
  const [OverleyModal, setOverleyModal] = useState("true");

  /* A hook that is executed when the component is mounted. */
  useEffect(() => {
    const cookiePrivacidad = new Cookies();
    (cookiePrivacidad.get("estado") === undefined) ? setOverleyModal("false") : setOverleyModal(cookiePrivacidad.get("estado"))
  }, [])

  /**
   * It sets the cookie to the value of the parameter cerrar.
   */
  const cerrarPrivacidad = (cerrar) => {
    const cookiePrivacidad = new Cookies();
    console.log(OverleyModal)
    cookiePrivacidad.set("estado", true)
    setOverleyModal(true)
  }



  const getImagenEmpresa = (id, lista, empresa) => {
    axios({
      method: "get",
      url: window.ipdirection + "imagenPerfilEmpresaCliente/" + id + "/",
      responseType: 'blob'
    }).then(response => {
      let newArray = [...Empresas]
      newArray.push({ ...empresa, img: URL.createObjectURL(response.data) })
      setEmpresas(newArray)
    });
  }

  /**
 * Recupera la lista de empresas y sus imágenes de perfil.
 * Actualiza el estado Empresas con la lista de empresas que incluyen sus imágenes de perfil.
 * @returns {Promise<void>}
 */
  const getEmpresas = async () => {
    try {
      // Recupera la lista de empresas.
      const response = await axios.get(window.ipdirection + "prestadorServiciosCliente/");
      const empresas = response.data;

      // Crea una promesa por cada empresa para recuperar su imagen de perfil y crear una URL.
      const empresasConImagenes = await Promise.all(
        empresas.map(async empresa => {
          try {

            const imagenResponse = await axios.get(window.ipdirection + `imagenPerfilEmpresaCliente/${empresa.id}/`, {
              responseType: "blob"
            });
            const imagenURL = URL.createObjectURL(imagenResponse.data);
            // Devuelve un objeto que contiene los detalles de la empresa y la URL de su imagen de perfil.
            return { ...empresa, img: imagenURL };
          } catch (error) {
            return { ...empresa, img: "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.omgtb.com%2Fwp-content%2Fuploads%2F2021%2F04%2F620_NC4xNjE-768x768.jpg&f=1&nofb=1&ipt=6e70641a1d064ed7a25e8f5428a004d5f8b720a9ae21a2028f48a538530174b2&ipo=images" };
          }
        })
      );

      // Actualiza el estado Empresas con la lista de empresas que incluyen sus imágenes de perfil.
      setEmpresas(empresasConImagenes);
    } catch (error) {
      console.log(error);
    }
  };

  const getEmpresas_preRegistradas = async () => {
    // const response = await axios.get(window.ipdirection + "prestadorServiciosPreCargados/?limite="+limite);
    
    const response = await axios.get(window.ipdirection + "BusquedaAvanzada_PreRegistrados/?nombreEmpresa="+buscarNombre+"&categoria_id="+buscarCategoria+'&categoria_nombre=' +buscarNombre+"&localidad_id="+buscarLocalidad+"&provincia_id="+buscarProvincia+"&limite="+limite,)
    const empresasCargadasList = response.data
    const empresasCargadasConImagenes = await Promise.all(
      empresasCargadasList.map(async empresa => {
        const imagenDefault = "https://cdn-icons-png.flaticon.com/512/883/883360.png";

          return { ...empresa, img: imagenDefault};
      })
    );
    setEmpresasCargadas(empresasCargadasConImagenes)
  }


  // El estado MenuLateralAux indica si el menú lateral está abierto o cerrado.
  const [MenuLateralAux, setMenuLateralAux] = useState();

  const chageMenuLateralAux = () => {
    setMenuLateralAux(!MenuLateralAux)
  };


return (
    <>
    <Helmet>
      <title>Cuidatia | Encuentra los mejores servicios de cuidado a domicilio</title>
      <link rel="canonical" href="https://www.cuidatia.org/" />
    </Helmet>
    <Modal centered={true} isOpen={MenuNoHayEmpresa}>
      <ModalHeader>
        <div className='titulo-modal'>
          No hay empresas en esta categoría
        </div>
      </ModalHeader>
      <ModalBody>
        <div className='descripcion-servicio descripcion-modal'>
          Todavia no hay empresas asociadas a esta categoría.
        </div>
      </ModalBody>
      <ModalFooter>
        <div className='centradorRight'>
          <div className='button' onClick={() => setMenuNoHayEmpresa(false)}><b>Aceptar</b></div>
        </div>
      </ModalFooter>
    </Modal>

    {}

    {/* <MenuLateralAB seleccionado={15} MenuLateralAux={MenuLateralAux} chageMenuLateralAux={chageMenuLateralAux} /> */}
    <div onClick={closeMenu} Id="Market">
      {
        OverleyModal === "false" && <Modal
          cerrarPrivacidad={cerrarPrivacidad}
        />
      }
      <div className="headerMiPerfil"  >
        <HeaderHome
          chageMenuLateralAux={chageMenuLateralAux}
        />
      </div>
      <div className="body" Id="bodyMarket1" >
      {/* <BuscadorHome
          Empresas={Empresas}
          setEmpresas={setEmpresas}
          mapa={Mapa}
          setMapa={setMapa}
          setModalUbiacion={setModalUbiacion}
          setEmpresasCargadas={setEmpresasCargadas}
          getEmpresas_preRegistradas={getEmpresas_preRegistradas}
          setBuscarNombre={setBuscarNombre}
          setBuscarCategoria={setBuscarCategoria}
          setBuscarLocalidad={setBuscarLocalidad}
          setBuscarProvincia={setBuscarProvincia}
          limite={limite}
        /> */}
        <BannerMarket 
          Empresas={Empresas}
          setEmpresas={setEmpresas}
          mapa={Mapa}
          setMapa={setMapa}
          setModalUbiacion={setModalUbiacion}
          setEmpresasCargadas={setEmpresasCargadas}
          getEmpresas_preRegistradas={getEmpresas_preRegistradas}
          setBuscarNombre={setBuscarNombre}
          setBuscarCategoria={setBuscarCategoria}
          setBuscarLocalidad={setBuscarLocalidad}
          setBuscarProvincia={setBuscarProvincia}
                  chageMenuLateralAux={chageMenuLateralAux}
                />
                 <div className='feature-one d-grid justify-center mb-5 mt-5'>
                        <div className="d-flex align-items-center mb-2">
                            <div className="icon">💼</div>
                            <div>
                                <div className="info-title">Eres profesional</div>
                                <div className="info-subtitle">Ofrece servicios sociosanitarios y sociosanitarios in tu zona</div>
                            </div>
                        </div>
                        <div className="highlight-box">
                            <ul>
                            <li><span className="bold-green">Visibilidad inmediata</span> en un marketplace especializado</li>
                            <li><span className="bold-green">Agenda digital</span> y facturación electrónica</li>
                            <li><span className="bold-green">Control de precios y disponibilidad</span></li>
                            <li>Formación, networking y acceso a programas públicos</li>
                            <li><span className="bold-green">Promociona tu negocio</span> sin invertir en publicidad</li>
                            </ul>
                        </div>
                    </div> 

                              <div className="container">
                                  <div className="titulo-pasos">
                                      <p className='h3-about'>Una plataforma para <span>personalizar</span> los cuidados y <span>simplificar</span> la gestión</p>
                                  </div>
                                  {/* Primera fila */}
                                  <div className="d-flex justify-content-center flex-wrap gap-4 mb-5 primera-fila">
                                      <div className="paso publico p-3 mt-2">
                                          <img className='res-img rounded-circle w-25' src={paso1} alt="paso 1" />
                                          <div className="p-3">
                                              <p className="w-100 h3-about pb-2"> Administraciones públicas </p>
                                              <p className="text-about">
                                                  Las administraciones públicas pueden gestionar y supervisar programas de atención domiciliaria, 
                                                  envejecimiento activo y prevención de la dependencia desde una única plataforma. Los indicadores de impacto,
                                                  los cuadros de mando y la coordinación entre municipios, entidades y proveedores facilitan la toma de decisiones
                                                  y mejoran la eficiencia de los servicios públicos.
                                              </p>
                                          </div>
                                      </div>
                                      <div className="paso privado p-3 mt-2">
                                          <img className='res-img rounded-circle w-25' src={paso2} alt="paso 2"/>
                                          <div className="p-3">
                                              <p className="w-100 h3-about pb-2"> Empresas y entidades sociosanitarias </p>
                                              <p className="text-about">
                                                  Las empresas y entidades sociosanitarias encuentran en Cuidatia una plataforma para integrar
                                                  todos sus servicios, gestionar usuarios y realizar un seguimiento completo de los resultados 
                                                  obtenidos. Además, facilita la creación de nuevos productos de cuidados, mejora la diferenciación 
                                                  frente a la competencia y ofrece acceso a un marketplace de servicios que amplía las oportunidades 
                                                  de colaboración y crecimiento.
                                              </p>
                                          </div>
                                      </div>
                                    </div>
                                      {/* Segunda fila */}
                                      <div className="d-flex justify-content-center flex-wrap gap-4 segunda-fila">
                                      <div className="paso publico p-3 mt-2">
                                          <img className='res-img rounded-circle w-25' src={paso3} alt="Paso 3" />
                                          <div className="p-3" >
                                              <p className="w-100 h3-about pb-2"> Servicios de Ayuda a Domicilio </p>
                                              <p className="text-about">
                                                Los servicios de ayuda a domicilio cuentan con toda la información necesaria 
                                                para ofrecer cuidados personalizados en el hogar. La plataforma facilita la 
                                                coordinación de auxiliares, el registro de actuaciones e incidencias, la comunicación
                                                con las familias y la integración con sensores y dispositivos para un seguimiento continuo y seguro.
                                              </p>
                                          </div>
                                      </div>
                                      <div className="paso publico p-3 mt-2">
                                          <img className='res-img rounded-circle w-25' src={paso4} alt="Paso 3" />
                                          <div className="p-3" >
                                              <p className="w-100 h3-about pb-2"> Centros de día </p>
                                              <p className="text-about">
                                                  Los centros de día pueden conocer mejor a cada usuario desde su incorporación, diseñando actividades
                                                  significativas acordes a sus preferencias, capacidades 
                                                  y motivaciones. El seguimiento continuo de la evolución y la coordinación con la familia garantizan 
                                                  una atención coherente y una transición fluida entre el centro y el domicilio.
                                              </p>
                                          </div>
                                      </div>
                                      <div className="paso publico p-3 mt-2">
                                          <img className='res-img rounded-circle w-25' src={paso5} alt="Paso 3" />
                                          <div className="p-3" >
                                              <p className="w-100 h3-about pb-2"> Residencias </p>
                                              <p className="text-about">
                                                  Las residencias disponen de una plataforma que acompaña a la persona desde antes de su ingreso, 
                                                  facilitando una acogida personalizada basada en su Historia de Vida. La coordinación entre profesionales, 
                                                  la comunicación con las familias y la planificación de actividades físicas y cognitivas permiten ofrecer 
                                                  una atención verdaderamente centrada en la persona y adaptada a sus necesidades.
                                              </p>
                                          </div>
                                      </div>
                                      <div className="paso privado p-3 mt-2">
                                          <img className='res-img rounded-circle w-25' src={paso6} alt="Paso 3" />
                                          <div className="p-3" >
                                              <p className="w-100 h3-about pb-2"> Promoción de autonomía</p>
                                              <p className="text-about">
                                                  Profesionales como fisioterapeutas, terapeutas ocupacionales, logopedas o podólogos
                                                  disponen de un entorno compartido donde registrar intervenciones, conocer la Historia
                                                  de Vida y coordinar sus actuaciones con el resto del equipo. De este modo, cada 
                                                  intervención contribuye a un objetivo común: mantener y potenciar la autonomía de la persona.
                                              </p>
                                          </div>
                                      </div>
                                      </div>
                              </div>
                              <div className="container my-5">
                                  <div className="titulo-pasos">
                                      <p className='h3-about'>Menos burocracia, más <span>tiempo para cuidar</span></p>
                                  </div>
                              </div>
                <SectionOneProovedores />

                  {/* <!-- ¿POR QUÉ ELEGIR CUIDATIA? --> */}
        <div class="container mt-5">
          <h2 className="h2-about text-uppercase">¿Por qué elegir CUIDATIA?</h2>
          <div className="text-about mt-5">
            <p>¿Buscas cuidados a domicilio de confianza, un fisioterapeuta que acuda a tu casa o simplemente saber qué opciones hay en tu pueblo o zona rural?</p>
            <p>¿Eres un profesional de la salud o la atención que quiere ampliar su red de clientes y trabajar con más libertad?</p>
            <p>¿Gestionas recursos públicos y necesitas mejorar el acceso a los servicios sociosanitarios de tu comunidad?</p>
            <p><strong>Bienvenido a CUIDATIA</strong>, el primer marketplace de salud y cuidados que facilita el encuentro entre quienes necesitan atención y quienes pueden ofrecerla.</p>
          </div>
        </div>

              {/* <!-- ¿QUÉ PUEDES HACER CON CUIDATIA? --> */}
        <div className="container my-5">
          <h2 className="h2-about text-uppercase">¿Qué puedes hacer con CUIDATIA?</h2>
          <ul className="text-about my-5" style={{ listStyleType: "disc" }}>
            <li className="mt-1">Contratar cuidadores online, de forma segura y sin complicaciones.</li>
            <li className="mt-1">Buscar servicios sociosanitarios en tu zona, adaptados a mayores y personas dependientes.</li>
            <li className="mt-1">Reservar cita con profesionales sanitarios rurales, estés donde estés.</li>
            <li className="mt-1">Ofrecer tus servicios como profesional, con herramientas para gestionar agenda, facturación y visibilidad.</li>
            <li className="mt-1">Digitalizar la atención sociosanitaria, fomentando el acceso equitativo en cualquier rincón del país.</li>
          </ul>
        </div>

                  <div className="fooderMarket">
                        <MiFooter />
                      </div>
                
              </div>
            </div>
            </>
          );
        }
        
        export default Proveedores;